export default __webpack_public_path__ + "665c458f761da857c6c78f9184bb8780.jpg";